import { Link } from 'react-router-dom';

/**
 * Reusable Breadcrumb component.
 * items: [{ label: string, href?: string }]
 * Last item is always rendered as plain text (current page).
 */
const Breadcrumb = ({ items = [] }) => {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-[12.5px] mb-6">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1 min-w-0">
            {idx > 0 && (
              <svg
                className="text-slate-300 shrink-0 mx-0.5"
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            )}

            {isLast ? (
              <span
                className="font-medium text-light-500 truncate"
                aria-current="page"
              >
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href}
                className="text-slate-400 hover:text-blue-600 transition-colors truncate"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
